import { render, staticRenderFns } from "./IconDetailsCard.vue?vue&type=template&id=2f3fd384&scoped=true&"
import script from "./IconDetailsCard.vue?vue&type=script&lang=js&"
export * from "./IconDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./IconDetailsCard.vue?vue&type=style&index=0&id=2f3fd384&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3fd384",
  null
  
)

export default component.exports